import logger from '../lib/logger'

export default function({ store, query }) {
  if (query.set_next_package) {
    logger.debug(
      'deeplink-next-package: Adding next package to the cart: ',
      query.set_next_package
    )

    store.commit('cart/setDeepLinkedPackage', query.set_next_package)
  }
}
